import React, { useState } from "react";
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import { Button, FormLabel, IconButton, Stack, TextField } from "@mui/material";
import Api from "../../network/Api";
import Toolbox from "../Shared/Toolbox";

const FeedbackButtons = (props: { conversationId: string, messageId: string }) => {

  const [negative, setNegative] = useState<boolean>(false);
  const [comment, setComment] = useState<string>();
  const [sent, setSent] = useState<boolean>(false);

  const updateSentiment = (type: "positive" | "negative", comment?: string) => {
    Api.post(`/conversations/${props.conversationId}/messages/${props.messageId}/feedbacks`, { sentiment: type, comment: comment }).then(() => setSent(true));
    setNegative(false);
  }

  return <>{ !sent && <Stack direction="row" spacing={0}>
    <IconButton size="small"><ThumbUpOffAltIcon fontSize="small" onClick={() => updateSentiment("positive")} /></IconButton>
    <IconButton size="small"><ThumbDownOffAltIcon fontSize="small" onClick={() => setNegative(true)} /></IconButton>

    { negative && <Toolbox title="Feedback" maxWidth="sm" onClose={() => setNegative(false)}>
      <FormLabel>Do you want to add a comment?</FormLabel>
      <TextField variant="filled" multiline rows={3} placeholder="Comment" value={comment} onChange={e => setComment(e.currentTarget.value)} />
      <Button variant="outlined" color="secondary" onClick={() => updateSentiment("negative", comment)}>Confirm</Button>
    </Toolbox> }
  </Stack> }</>;
}

export default FeedbackButtons;